import { useQuery } from "@tanstack/react-query";
import { fetchPendingPriceChanges } from "../api/fetchPendingPriceChanges";

export const usePendingPriceChanges = (filters = {}, enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["pendingPriceChanges", filters],
    queryFn: () => fetchPendingPriceChanges(filters),
    enabled,
  });

  return {
    data: data?.result || [],
    error,
    isLoading,
    refetch,
  };
};

